import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

function MessageItem({ isMine, text, dateSent, image, senderName }) {
  const { t, i18n } = useTranslation('messaging')
  const timestamp = dateSent
    ? new Intl.DateTimeFormat(i18n.language, {
        hour: 'numeric',
        minute: '2-digit',
      }).format(new Date(dateSent))
    : ''

  return (
    <MessageRow $mine={isMine}>
      <BubbleColumn $mine={isMine}>
        <Sender $mine={isMine}>
          {isMine ? t('participants.you') : senderName || t('participants.member')}
        </Sender>
        {image && (
          <ImageBubble $mine={isMine}>
            <img src={image} alt={t('conversation.imageAlt')} />
          </ImageBubble>
        )}
        {text && <Bubble $mine={isMine}>{text}</Bubble>}
        <Time>{timestamp}</Time>
      </BubbleColumn>
    </MessageRow>
  )
}

export default MessageItem

const MessageRow = styled.div`
  display: flex;
  justify-content: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
  margin: 8px 0;
`

const BubbleColumn = styled.div`
  max-width: 74%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
`

const Sender = styled.span`
  margin: 0 7px 4px;
  color: #7b8589;
  font-size: 10px;
  text-align: ${({ $mine }) => ($mine ? 'right' : 'left')};
`

const bubbleShape = ({ $mine }) =>
  $mine ? '16px 16px 4px 16px' : '16px 16px 16px 4px'

const Bubble = styled.div`
  padding: 10px 13px;
  border-radius: ${bubbleShape};
  background: ${({ $mine }) => ($mine ? 'rgba(0,180,204,.16)' : 'white')};
  color: #293539;
  font-size: 13px;
  line-height: 1.45;
  box-shadow: 0 1px 2px rgba(20, 35, 40, 0.08);
  white-space: pre-wrap;
  word-break: break-word;
`

const ImageBubble = styled.div`
  width: min(320px, 100%);
  margin-bottom: 5px;
  overflow: hidden;
  border-radius: ${bubbleShape};
  background: white;
  box-shadow: 0 1px 2px rgba(20, 35, 40, 0.08);

  img {
    display: block;
    width: 100%;
    max-height: 320px;
    object-fit: cover;
  }
`

const Time = styled.span`
  min-height: 13px;
  margin: 3px 6px 0;
  color: #9aa3a6;
  font-size: 9px;
`
